import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "rd-grid rd-grid-cols-12 rd-gap-x-5 rd-gap-y-3.5 rd-w-full test-payments-ach" }
const _hoisted_2 = { class: "rd-relative rd-col-span-12 md:rd-col-span-4 md:rd-top-6" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "rd-col-span-12 rd-relative rd-text-left sm:rd-col-span-6 md:rd-col-span-4" }
const _hoisted_5 = {
  key: 0,
  class: "fa-solid fa-check rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 1,
  class: "fa-solid fa-copy rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "rd-col-span-12 rd-relative rd-text-left sm:rd-col-span-6 md:rd-col-span-4" }
const _hoisted_8 = {
  key: 0,
  class: "fa-solid fa-check rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 1,
  class: "fa-solid fa-copy rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_10 = {
  key: 0,
  class: "rd-text-sm rd-mt-4"
}

import { Tooltip } from "floating-vue";
import { reactive } from "vue";

enum ACHType {
    Successful = 1,
    Failure = 2,
}

interface DataObject {
    achType: ACHType;
    routingNumber: string;
    isRoutingNumberCopied: boolean;
    routingNumberTooltip: string;
    accountNumber: string;
    isAccountNumberCopied: boolean;
    accountNumberTooltip: string;
    disabledTooltip: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TestPaymentsAch',
  setup(__props) {

const testAchTypes = [
    {
        text: "ACH - Successful",
        value: ACHType.Successful,
    },
    {
        text: "ACH - Failure",
        value: ACHType.Failure,
    },
];

const data = reactive<DataObject>({
    achType: ACHType.Successful,
    routingNumber: "111000025",
    isRoutingNumberCopied: false,
    routingNumberTooltip: "Copy to clipboard",
    accountNumber: "12121212",
    isAccountNumberCopied: false,
    accountNumberTooltip: "Copy to clipboard",
    disabledTooltip: false,
});

// methods
const copyRoutingNumber = () => {
    navigator.clipboard.writeText(data.routingNumber);
    data.isRoutingNumberCopied = true;
    data.routingNumberTooltip = "Copied!";

    setTimeout(function () {
        data.isRoutingNumberCopied = false;
        data.routingNumberTooltip = "Copy to clipboard";
    }, 2000);
};

const copyAccountNumber = () => {
    navigator.clipboard.writeText(data.accountNumber);
    data.isAccountNumberCopied = true;
    data.accountNumberTooltip = "Copied!";

    setTimeout(function () {
        data.isAccountNumberCopied = false;
        data.accountNumberTooltip = "Copy to clipboard";
    }, 2000);
};

const isSmallerScreen = () => {
    data.disabledTooltip = window.innerWidth < 768;
};

window.addEventListener("resize", isSmallerScreen);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          for: "testAchs",
          class: "rd-sr-only"
        }, " Test Payment Methods ", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "testAchs",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.achType) = $event)),
          class: "rd-pr-[30px]"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("option", {
            disabled: "",
            value: ""
          }, "Please select", -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(testAchTypes, (item) => {
            return _createElementVNode("option", {
              key: item.value,
              value: item.value
            }, _toDisplayString(item.text), 9, _hoisted_3)
          }), 64))
        ], 512), [
          [_vModelSelect, data.achType]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "routingNumber" }, "Routing", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "routingNumber",
          readonly: "",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.routingNumber) = $event))
        }, null, 512), [
          [_vModelText, data.routingNumber]
        ]),
        _createVNode(_unref(Tooltip), {
          distance: "-4",
          container: ".test-payment-types",
          delay: "15",
          popperClass: "tooltip-sm",
          class: "rd-absolute rd-right-0 rd-bottom-0",
          disabled: data.disabledTooltip
        }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(data.routingNumberTooltip), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "rd-py-[13px] rd-px-[15px] copy-routing-number",
              onClick: copyRoutingNumber
            }, [
              (data.isRoutingNumberCopied)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : (_openBlock(), _createElementBlock("i", _hoisted_6)),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "rd-sr-only" }, "Copy Test Routing Number to clipboard", -1))
            ])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "accountNumber" }, "Account", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "accountNumber",
          readonly: "",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.accountNumber) = $event))
        }, null, 512), [
          [_vModelText, data.accountNumber]
        ]),
        _createVNode(_unref(Tooltip), {
          distance: "-4",
          container: ".test-payment-types",
          delay: "15",
          popperClass: "tooltip-sm",
          class: "rd-absolute rd-right-0 rd-bottom-0",
          disabled: data.disabledTooltip
        }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(data.accountNumberTooltip), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "rd-py-[13px] rd-px-[15px] copy-account-number",
              onClick: copyAccountNumber
            }, [
              (data.isAccountNumberCopied)
                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                : (_openBlock(), _createElementBlock("i", _hoisted_9)),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "rd-sr-only" }, "Copy Test Account Number to clipboard", -1))
            ])
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    (data.achType === ACHType.Failure)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[9] || (_cache[9] = [
          _createElementVNode("strong", null, "Note:", -1),
          _createTextVNode(" to test an ACH failure, enter a donation amount greater than $100 ")
        ])))
      : _createCommentVNode("", true)
  ], 64))
}
}

})